module.exports = __webpack_public_path__ + "static/media/art17.c8325049.jpg";